import TenantContextPropsType from './ContextPropTypes';

export const actions = {
  AVAILABLE_TENANTS_LOADED: 'AVAILABLE_TENANTS_LOADED',
  SET_AVAILABLE_TENANTS: 'SET_AVAILABLE_TENANTS',
  CURRENT_TENANT_LOADED: 'CURRENT_TENANT_LOADED',
  SET_CURRENT_TENANT: 'SET_CURRENT_TENANT',

  FETCHING_DATA: 'FETCHING_DATA',
  FETCHING_SUCCESS: 'FETCHING_SUCCESS',
  FETCHING_ERROR: 'FETCHING_ERROR',

  SET_MESSAGE: 'SET_MESSAGE',
};

export function reducer(state: any, action: any): TenantContextPropsType {
  switch (action.type) {
    case actions.FETCHING_DATA:
      return {
        ...state,
        loadingData: true,
      };
    case actions.FETCHING_SUCCESS:
      return {
        ...state,
        loadingData: false,
      };
    case actions.FETCHING_ERROR:
      return {
        ...state,
        loadingData: false,
        msg: action.payload.msg,
      };
    case actions.SET_AVAILABLE_TENANTS: {
      return {
        ...state,
        fetchingData: false,
        tenantsLoaded: true,
        availableTenants: action.payload,
      };
    }
    case actions.SET_CURRENT_TENANT: {
      return {
        ...state,
        fetchingData: false,
        currentTenantLoaded: true,
        currentTenant: action.payload,
      };
    }
    case actions.SET_MESSAGE:
      return {
        ...state,
        msg: action.payload.msg,
      };
    default:
      return state;
  }
}
